import { EditFRDMeasurementTask, FRDMeasurementTask } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickFrdLibraryFields } from "../../../schema/frd-schema-library";

const sharedTitle = (type: FormType | undefined) => `FRD-Meting ${getTitleAddon(type)}`;
const sharedDescription = `Dit is het FRD Meting formulier. Gebruik het template om de meetwaardes door te geven. ${getDocsLinkMarkdown(
  "FRD"
)}`;

const sharedSourcedocumentData = {
  type: "object" as const,
  required: [
    "measurementDate",
    "measurementOperatorKvk",
    "determinationProcedure",
    "evaluationProcedure",
  ],
  properties: {
    ...pickFrdLibraryFields([
      "measurementDate",
      "measurementOperatorKvk",
      "determinationProcedure",
      "evaluationProcedure",
    ]),
  },
};

const getFrdMeasurementCreateSchema = (
  type: FormType | undefined
): SchemaForFormData<FRDMeasurementTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData", "measurementFile"],
  properties: {
    metadata: {
      type: "object",
      required: ["projectNumber", "broId", "qualityRegime", "deliveryAccountableParty"],
      properties: pickFrdLibraryFields([
        "projectNumber",
        "broId",
        "qualityRegime",
        "deliveryAccountableParty",
      ]),
    },
    sourcedocumentData: sharedSourcedocumentData,
    ...pickFrdLibraryFields(["measurementFile"]),
  },
});

const getFrdMeasurementEditSchema = (
  type: FormType | undefined
): SchemaForFormData<EditFRDMeasurementTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData", "measurementFile"],
  properties: {
    metadata: {
      type: "object",
      required: [
        "projectNumber",
        "broId",
        "qualityRegime",
        "deliveryAccountableParty",
        "correctionReason",
      ],
      properties: {
        ...pickFrdLibraryFields([
          "projectNumber",
          "qualityRegime",
          "deliveryAccountableParty",
          "correctionReason",
        ]),
        broId: { ...pickFrdLibraryFields(["broId"]).broId, readOnly: true },
      },
    },
    sourcedocumentData: sharedSourcedocumentData,
    ...pickFrdLibraryFields(["measurementFile"]),
  },
});

export function getFrdMeasurementSchema(args: {
  type: FormType | undefined;
  isEditing: true;
}): SchemaForFormData<EditFRDMeasurementTask>;
export function getFrdMeasurementSchema(args: {
  type: FormType | undefined;
  isEditing: false;
}): SchemaForFormData<FRDMeasurementTask>;
export function getFrdMeasurementSchema(args: {
  type: FormType | undefined;
  isEditing: boolean;
}): SchemaForFormData<EditFRDMeasurementTask> | SchemaForFormData<FRDMeasurementTask>;
export function getFrdMeasurementSchema({
  type,
  isEditing,
}: {
  type: FormType | undefined;
  isEditing: boolean;
}) {
  return isEditing ? getFrdMeasurementEditSchema(type) : getFrdMeasurementCreateSchema(type);
}
